var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#21a366",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.96094,2c-0.12147,-0.00364 -0.24259,0.01489 -0.35742,0.05469l-20.93164,7.28516c-0.44485,0.15475 -0.72144,0.59892 -0.66406,1.06641l3.30664,27.12305c0.03919,0.32113 0.2313,0.60347 0.51563,0.75781l17.64648,9.5918c0.29915,0.16265 0.6605,0.16191 0.95898,-0.00195l17.73828,-9.72266c0.28231,-0.15488 0.47278,-0.43622 0.51172,-0.75586l3.30664,-27.12109c0.05763,-0.46978 -0.22195,-0.91562 -0.66992,-1.06836l-21.06836,-7.15625c-0.09448,-0.03209 -0.19323,-0.04987 -0.29297,-0.05273zM24.9375,4.05859l19.9707,6.7832l-3.14648,25.80664l-16.80859,9.21289l-16.71484,-9.08594l-3.14844,-25.81055zM25.03516,6c-0.40142,-0.01382 -0.77217,0.21386 -0.94141,0.57813l-13,28c-0.14401,0.30963 -0.12009,0.67134 0.06345,0.9593c0.18354,0.28797 0.50132,0.46238 0.8428,0.46257h4.4375c0.38877,-0.00018 0.74221,-0.22565 0.90625,-0.57812l2.51367,-5.41406h10.28516l2.51367,5.41406c0.16404,0.35247 0.51748,0.57794 0.90625,0.57813h4.4375c0.34148,-0.00019 0.65926,-0.17461 0.8428,-0.46257c0.18354,-0.28797 0.20746,-0.64967 0.06345,-0.9593l-13,-28c-0.1585,-0.34122 -0.4951,-0.56461 -0.87109,-0.57812zM25,9.37305l11.43359,24.62695h-2.23242l-2.51367,-5.41406c-0.16404,-0.35247 -0.51748,-0.57794 -0.90625,-0.57813h-11.5625c-0.38877,0.00018 -0.74221,0.22565 -0.90625,0.57813l-2.51562,5.41406h-2.23047zM25.03906,15.5c-0.40444,-0.01554 -0.77837,0.21422 -0.94727,0.58203l-3.92578,8.51172c-0.14237,0.30958 -0.11733,0.67034 0.06645,0.95727c0.18378,0.28693 0.50101,0.46056 0.84175,0.4607h7.85156c0.34074,-0.00014 0.65797,-0.17376 0.84175,-0.4607c0.18378,-0.28693 0.20882,-0.6477 0.06645,-0.95727l-3.92578,-8.51172c-0.15708,-0.34213 -0.49297,-0.56707 -0.86914,-0.58203zM25,18.88672l2.36328,5.125h-4.72656z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.c2b785a89a03bc53cd79530e5335a5ab.svg";
export { ForwardRef as ReactComponent };